import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'signet-circular-data-widget',
  styleUrl: 'signet-circular-data-widget.scss',
  shadow: false,
})
export class SignetCircularDataWidget {
  @Prop() progress: number;
  @Prop() progressUpperText: string;
  @Prop() progressLowerText: string;
  @Prop() progressIcon: string;
  @Prop() cardTitle: string;
  @Prop() cardDescription: string;
  @Prop() buttonText: string;

  render() {
    return (
      <div class="circular-data-widget">
        <p class="card-title">{this.cardTitle}</p>
        <signet-circular-progress-bar
          icon={this.progressIcon}
          upperText={this.progressUpperText}
          lowerText={this.progressLowerText}
          progress={this.progress}
        />
        <p class="card-description">{this.cardDescription}</p>
        <signet-button class="primary">{this.buttonText}</signet-button>
      </div>
    );
  }
}
